module.exports = __webpack_public_path__ + "static/media/playstore.4884ad87.svg";